import { Form } from "common/Forms";
import { TableRenderer } from "common/Table";

export const TableView = ({ feeCards, onDownloadInvoice }) => {
  return (
    <Form>
      <TableRenderer
        data={feeCards ?? []}
        columns={
          [
            {
              name: 'Site ID',
              bodyRenderer: x => x?.siteid || <div style={{ textAlign: 'center' }}>-</div>
            },
            {
              name: 'Client Name',
              bodyRenderer: x => x?.clientName || <div style={{ textAlign: 'center' }}>-</div>
            },
            {
              name: 'Start Date',
              bodyRenderer: x => x?.fromDate || <div style={{ textAlign: 'center' }}>-</div>
            },
            {
              name: 'End Date',
              bodyRenderer: x => x?.toDate || <div style={{ textAlign: 'center' }}>-</div>
            },
            {
              name: 'Ordering Options',
              bodyRenderer: x => x?.option || <div style={{ textAlign: 'center' }}>-</div>
            },
            {
              name: 'Payment Method',
              bodyRenderer: x => x?.paymentMethod || <div style={{ textAlign: 'center' }}>-</div>
            },
            {
              name: 'Total',
              bodyRenderer: x => `${x?.orderGrandTotal || '-'} ${x?.currency ? `(${x?.currency?.toUpperCase()})` : ''}`,
            },
            {
              name: 'Fees',
              bodyRenderer: x => `${x?.totalAdminFee || '-'} ${x?.currency ? `(${x?.currency?.toUpperCase()})` : ''}`,
            },
            {
              name: 'Sales',
              bodyRenderer: x => `${x.totalSalesFee || '-'} ${x?.currency ? `(${x?.currency?.toUpperCase()})` : ''}`,
            },
          ]
        }
      />
    </Form>
  )
}